import { useSprintMutation, useSprintQueryClient, SprintMutationResult } from "sprint-common-web";

import { UpdateBulkCloudAssetContentResponse } from "../../../../../../../../common/api/master-api/assets/bulk-content/UpdateBulkCloudAssetContentResponse";
import { ValidateBulkCloudAssetContentRequest } from "../../../../../../../../common/api/master-api/assets/bulk-content/ValidateBulkCloudAssetContentRequest";
import { ValidateBulkCloudAssetContentResponse } from "../../../../../../../../common/api/master-api/assets/bulk-content/ValidateBulkCloudAssetContentResponse";
import { useAssetsApi } from "../../../../../../../../common/api/master-api/assets/useAssetsApi";
import { CloudAssetQueryKey } from "../../../../../common/CloudAssetQueryKey";

export interface UseBulkEditCloudAssetContent {
    validateBulkCloudAssetContent: SprintMutationResult<
        ValidateBulkCloudAssetContentRequest,
        ValidateBulkCloudAssetContentResponse
    >;
    updateBulkCloudAssetContent: SprintMutationResult<
        ValidateBulkCloudAssetContentRequest,
        UpdateBulkCloudAssetContentResponse
    >;
}

export const useBulkEditCloudAssetContent = ({
    invalidationKey
}: {
    invalidationKey?: string;
}): UseBulkEditCloudAssetContent => {
    const assetsApi = useAssetsApi();
    const sprintQueryClient = useSprintQueryClient();

    const validateBulkCloudAssetContent = useSprintMutation<
        ValidateBulkCloudAssetContentRequest,
        ValidateBulkCloudAssetContentResponse
    >({
        mutationFn: async ({ assetId, contentReference }) => {
            if (!assetId) {
                throw new Error("Asset ID is required to validate bulk cloud asset content.");
            }

            return assetsApi.validateBulkCloudAssetContent({ assetId, contentReference });
        }
    });

    const updateBulkCloudAssetContent = useSprintMutation<
        ValidateBulkCloudAssetContentRequest,
        UpdateBulkCloudAssetContentResponse
    >({
        mutationFn: async ({ assetId, contentReference }) => {
            if (!assetId) {
                throw new Error("Asset ID is required to update bulk cloud asset content.");
            }

            return assetsApi.updateBulkCloudAssetContent({ assetId, contentReference });
        },
        onSettled: async () => {
            await sprintQueryClient.invalidateQueries({
                queryKey: [CloudAssetQueryKey.ConformingCloudAssets, invalidationKey]
            });
        }
    });

    return {
        validateBulkCloudAssetContent,
        updateBulkCloudAssetContent
    };
};
